
import { removeNewLineWhitespace } from "@/app/infrastructures/misc/Utils";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { PusatResolusiV2Controller } from "@/app/ui/controllers/PusatResolusiV2Controller";
import { Options, prop, Vue } from "vue-class-component";
import Draggable from "vuedraggable";
import { AddTemplatePusatResolusiRequest } from "@/data/payload/api/PusatResolusiV2ApiRequest";
import { TemplateChat } from "@/domain/entities/PusatResolusiV2";
import CardAddTemplate from "./card-add-template.vue";

class Props {
  modelValue = prop<boolean>({
    default: false,
    type: Boolean,
    required: true
  });
  data = prop<TemplateChat[]>({
    default: [],
    type: Array,
    required: true
  });
}

@Options({
  components: {
    Draggable,
    CardAddTemplate
  },
  emits: ["update:modelValue"]
})
export default class AddTemplate extends Vue.with(Props) {
  mounted() {
    this.newTemplate = "";
    this.isFocusNewTemplate = false;

    this.templateList = JSON.parse(JSON.stringify(this.data));
    this.originalTemplateList = JSON.stringify(this.templateList);
  }

  // state
  newTemplate = "";
  isFocusNewTemplate = false;
  maxLengthNewTemplate = 1000;
  originalTemplateList = "";
  templateList: TemplateChat[] = [];

  // new template
  onFocusNewTemplate() {
    this.isFocusNewTemplate = true;
  }
  replaceNewLine(value: string) {
    const removedNewLineAddress = removeNewLineWhitespace(value, " ");
    this.newTemplate = removedNewLineAddress;
    return removedNewLineAddress;
  }
  get disabledNewTemplate() {
    return this.templateList.length >= 8;
  }
  onAdd() {
    if (!this.newTemplate.trim()) return;

    this.templateList.unshift(
      new TemplateChat({
        templateMessage: this.newTemplate,
        position: this.templateList.length + 1
      })
    );
    this.newTemplate = "";

    this.openSnackbar(
      this.$t('pusatResolusi.create.snackbarMessage')
    );
  }

  // template list
  onDrag() {
    this.openSnackbar(
      this.$t('pusatResolusi.create.snackbarMessageTemplateList')
    );
  }
  onDelete(data: TemplateChat) {
    this.templateList = this.templateList.filter(
      (item: TemplateChat) => item.position !== data.position
    );

    this.openSnackbar(
      this.$t('pusatResolusi.create.snackbarMessageDelete')
    );
    MainAppController.closeMessageModal();
  }

  // footer
  onClose() {
    MainAppController.setSnackbarRerender();
    this.$emit("update:modelValue", false);
  }
  get disabledSave(): boolean {
    return (
      this.originalTemplateList === JSON.stringify(this.templateList) &&
      !this.newTemplate
    );
  }
  onSave() {
    setTimeout(async () => {
      try {
        if (this.newTemplate.trim()) {
          this.onAdd();
        }

        await PusatResolusiV2Controller.addTemplate(
          new AddTemplatePusatResolusiRequest({
            data: this.templateList.map(
              (e: TemplateChat, index: number) =>
                new TemplateChat({
                  templateMessage: e.templateMessage,
                  position: index + 1
                })
            )
          })
        );

        this.openSnackbar(this.$t('pusatResolusi.create.snackbarMessageSuccess'));

        this.onClose();
        this.$emit("success", false);
      } catch (error) {
        MainAppController.setSnackbarRerender();
        await this.$nextTick();
        MainAppController.setSnackbarMessage(
          this.$t('pusatResolusi.create.snackbarMessageFailed')
        );
        MainAppController.setSnackbarTimeout(3000);
        MainAppController.setSnackbarPositivity(false);
        MainAppController.setSnackbar(true);
      }
    }, 55);
  }

  // utils
  async openSnackbar(message: string) {
    MainAppController.setSnackbarRerender();
    await this.$nextTick();
    MainAppController.setSnackbarMessage(message);
    MainAppController.setSnackbarTimeout(3000);
    MainAppController.setSnackbar(true);
  }
}
